<template>
  <div class="home">
    <section
      class="main no-flex"
      style="margin-top: 13px;"
    >

      <!-- <UsersAttendance
        :user="user"
      /> -->
      <EmployeeCalculationListing />
    </section>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex'
import EmployeeCalculationListing from '../components/calculation/EmployeeCalculationListing.vue'
// import UsersAttendance from '@/components/properties/UsersAttedance.vue'


export default {
  name: 'Home',
  components: {
    EmployeeCalculationListing,
    // UsersAttendance,
  },
  data() {
    return {
      user: '',
    }
  },
  computed: {
    ...mapGetters(['getIsLoading']),

  },
  methods: {
    materialId(id) {
      this.materialIdToShow = id
    },
    handleUser(id) {
      this.user = id;
    },
  },
}
</script>

<style scoped lang="scss">

.main{
  padding: 90px 15px 15px 110px;
}

@media screen and (max-width: 1200px){
  .main{
    padding: 90px 15px 15px 80px !important;
  }
}
@media screen and (max-width: 1041px) {
  .main {
    padding: 90px 0.75rem 15px 0.75rem;
  }
}

@media screen and (max-width: 1500px){
  .main{
    padding: 90px 15px 15px 120px;
  }
}
</style>
